var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNearAi = function SvgNearAi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 512 512"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#0091FD",
    rx: 110
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M373.89 106.199a31.95 31.95 0 0 0-27.213 15.207l-62.631 92.979a6.67 6.67 0 0 0-.989 5.001 6.66 6.66 0 0 0 2.837 4.235 6.67 6.67 0 0 0 8.032-.494l61.643-53.47c1.02-.924 2.599-.827 3.523.193.419.473.644 1.074.644 1.697v167.402a2.49 2.49 0 0 1-2.502 2.491 2.48 2.48 0 0 1-1.912-.891L168.976 117.497a31.93 31.93 0 0 0-24.356-11.298h-6.508c-17.623 0-31.917 14.294-31.917 31.917v235.767c0 17.623 14.294 31.917 31.917 31.917a31.94 31.94 0 0 0 27.213-15.206l62.631-92.98a6.66 6.66 0 0 0-1.847-9.236 6.67 6.67 0 0 0-8.033.494l-61.643 53.471c-1.02.923-2.599.826-3.522-.194a2.49 2.49 0 0 1-.634-1.697V173.008a2.49 2.49 0 0 1 2.502-2.492c.731 0 1.439.322 1.912.891l186.313 223.096a31.95 31.95 0 0 0 24.357 11.297h6.508c17.623 0 31.927-14.272 31.938-31.895V138.116c0-17.623-14.294-31.917-31.917-31.917"
  })));
};
export default SvgNearAi;